export default __webpack_public_path__ + "static/media/flor1.5fd88bfa.jpeg";